// extracted by mini-css-extract-plugin
export default {"policy":"Acceptance_policy__0MFil","wrapper":"Acceptance_wrapper__4iKaW","addr":"Acceptance_addr__dhSUB","points":"Acceptance_points__krriw","rules":"Acceptance_rules__Vnqop"};